<template>
  <Content>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:20px 0">
      <span style="float: left;">所在位置：</span>
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/list' }">大数据词云列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{wordCloud.shareName}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-bottom: 30px">
      <div slot="header" class="header-box">
        <div style="flex:1">
          <p>{{wordCloud.shareName}}</p>
          <p class="info-box">
            <span>
              {{wordCloud.nickName}} 发布于 {{wordCloud.shareTime}}
            </span>
            <!-- <span>
            浏览量：{{wordCloud.browseCount}}
            </span> -->
            <!-- <span>喜欢：{{wordCloud.likeCount}}</span> -->
          </p>
        </div>
        <div>
        <div style=" float: left; position: relative; margin-right: 10px;" v-if="showxt">
             <span class="xtbtn-box" style="position: relative;">
              <a id="akey" class="xt" :href="'//www.5118.com/xt/' + wordCloud.shareName"  target="_blank">
                  查看该选题
              </a>
              <span v-if="autotip" class="tigs">
                点击查看该关键词行业选题<span style="font-size: 15px;margin-left:10px;"  @click="closeautotip">×</span> 
              </span>
          </span>
         </div>

          <el-tooltip class="item" effect="dark" content="分享" placement="bottom">
            <el-button icon="el-icon-share" size="mini" class="icon-btn" @click="share"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="复制链接" placement="bottom">
            <el-button icon="el-icon-link" size="mini" class="icon-btn" @click="copy"></el-button>
          </el-tooltip>
          <!--          <el-button icon="el-icon-share" size="mini" class="icon-btn"></el-button>-->
          <el-tooltip class="item" effect="dark" content="下载图片" placement="bottom">
            <el-button icon="el-icon-download" size="mini" class="icon-btn" @click="download"></el-button>
          </el-tooltip>
        </div>
      </div>
      <div style="text-align: center">
        <img :src="wordCloud.pushPictureUrl" style="max-width: 100%">
      </div>
    </el-card>

    <el-dialog title="分享到微信朋友圈" :visible.sync="dialogVisible" center width="30%">
      <div style="margin: 0px auto;text-align: center;">
        <vue-qr class="bicode" :logoSrc="imagePath" :text="codeValue"></vue-qr>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

  </Content>
</template>

<script>
import { mapActions } from "vuex";
import VueQr from "vue-qr";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      guid: this.$route.params.guid,
      wordCloud: {},
      autotip:true,
      codeValue: "", //显示的值、跳转的地址
      icode: "",
      imagePath: "", //中间logo的地址
      dialogVisible: false,
      showxt: false
    };
  },
  created() {
    var Link = "/api/account/WxSignature";
    fetch(Link + "?url=" + encodeURIComponent(window.location.href.split("#")[0])).then(function (res) {
      return res.text();
    }).then(function (params) {
      var jsonObj = JSON.parse(params);

      if (jsonObj.ErrorCode) {
        return;
      }

      wx.config({
        debug: false,
        appId: jsonObj.Data.WxAppId,
        timestamp: jsonObj.Data.WxTimestamp,
        nonceStr: jsonObj.Data.WxNonceStr,
        signature: jsonObj.Data.WxSignature,
        jsApiList: [
          'updateTimelineShareData',
          'updateAppMessageShareData'
        ]
      });

    })

  },
  components: { VueQr },
  async mounted() {
    this.get();
  },
  methods: {
    ...mapActions("core", ["AGet", "ALike", "ADownload","AXtCheckName"]),
    async get() {
      let result = await this.AGet({ mainGuid: this.guid });
      this.wordCloud = result.data;
      this.initWX();
      var xtmodel = await this.AXtCheckName({
                keyword: this.wordCloud.shareName, 
                datatype: 'akey'
            });
      this.showxt = xtmodel.data.isExists && xtmodel.data.auditState == 100;
    },
    async like() {
      await this.ALike({ mainGuid: this.guid });
      this.wordCloud.likeCount++;
    },
    copy() {
      this.$copy(window.location.href);
      this.$alert("复制成功");
    },
    download() {
      this.ADownload({ mainGuid: this.guid });
    },
    share() {
      this.dialogVisible = true;
      this.codeValue = window.location.href;
    },
    closeautotip: function () {
       this.autotip = false;
    },
    initWX() {
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: '', // 分享标题
          desc: '', // 分享描述
          link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.wordCloud.pushPictureUrl + '?imageView2/1/w/300/h/300', // 分享图标
          success: function () {
          }
        })
        wx.updateTimelineShareData({
          title: '',
          link: window.location.href.split("#")[0],
          imgUrl: this.wordCloud.pushPictureUrl + '?imageView2/1/w/300/h/300',
          success: function (res) {
          }
        });

      });
    }
  }
};
</script>
<style type="text/less" lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";

.header-box {
  display: flex;
  height: 40px;
  align-items: center;

  .info-box {
    color: @color-text-secondary;
    font-size: @small-font-size;
    margin-top: 5px;

    > span {
      margin-right: 15px;
    }
  }

  .icon-btn {
    font-size: 18px !important;
    padding: 5px;
  }
}

.xtbtn-box .xt
{
    padding: 0 3px;
    line-height: 28px;
    border: 1px solid #2677F2;
    border-radius: 4px;
    color: #2677F2 !important;
    text-decoration: none !important;
    cursor: pointer;
    background-color: white !important;
    display: inline-block;
    font-size: 14px;
}
.tigs {
    position: absolute;
    top: 37px;
    left: 0px;
    height: 25px;
    line-height: 25px;
    padding: 0 5px;
    border: 1px solid #FED8A0 !important;
    color: #FEA638 !important;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    margin-bottom: 5px;
    background: #FEF8E4 !important;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    font-weight: normal!important;
}
.tigs:before {
    content: "";
    display: block;
    position: absolute;
    height: 8px;
    width: 8px;
    transform: rotate(-136deg);
    background-color: #FEF8E4 !important;
    bottom: 19px;
    left: calc(22% - 4px);
    border-right: 1px solid #FED8A0 !important;
    border-bottom: 1px solid #FED8A0 !important;
}
</style>
